

































import { CurrentFamily, Family } from '@/types';
import { VAlert, VButton, VHeader } from '@/components';
import { AlertMixin } from '@/mixins';
import { AlertStatus } from '@/utils/enums';
import Authentication from '@/utils/Authentication';
import { AuthorizationError } from '@/utils/errors';
import { Component } from 'vue-property-decorator';
import Firestore from '@/utils/Firestore';
import firebase from 'firebase';

@Component({
  components: { VAlert, VHeader, VButton }
})
export default class AppMain extends AlertMixin {
  invitations: Family[] = [];
  user: firebase.User | null = null;

  async mounted() {
    this.user = await Authentication.instance.getCurrentUser();
    await this.getInvitations();

    await CurrentFamily.instance.listenForChanges();
  }

  private async getInvitations() {
    this.invitations = await Firestore.instance.getInvitations(this.user?.email ?? '');
  }

  async handleAcceptInvite(familyId: string) {
    if (!this.user || !this.user.email) throw new AuthorizationError();

    try {
      await CurrentFamily.instance.switchTo(familyId, this.user.email);
      await this.getInvitations();
      await this.showAlert("You've accepted the invitation", AlertStatus.Success);
    } catch (e) {
      await this.showAlert("Couldn't accept the invitation", AlertStatus.Danger);
    }
  }

  async handleDeclineInvitation(familyId: string) {
    if (!this.user || !this.user.email) throw new AuthorizationError();

    try {
      await Firestore.instance.declineInvitation(familyId, this.user.email);
      await this.getInvitations();
      await this.showAlert('The invitation has been declined');
    } catch (e) {
      await this.showAlert("Couldn't decline the invitation", AlertStatus.Danger);
    }
  }
}
